import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { ChildGenderEnum } from '@sola/schema/dotcom/children/childUtilityInterfaces.ts';
import { endsWithVowel } from '@sola/utils/koreanGrammar.ts';
import { camelCase } from '@sola/utils/string.ts';
import { isHighlyVulnerable } from '../organisms-cms/child-bio/utils/childNote.tsx';
export const useSacImageAltText = (gender, country, hangul, minDaysWaiting, preferredName, isOrphan, isSpecialNeeds, isInHivAffectedArea) => {
  const $ = _c(23);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["bio", "children", "geo"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const t1 = `children:child.pictureAlt_${gender as string}`;
  const t2 = country as string;
  let t3;
  if ($[1] !== t2) {
    t3 = camelCase(t2);
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== country || $[4] !== gender || $[5] !== hangul || $[6] !== isInHivAffectedArea || $[7] !== isOrphan || $[8] !== isSpecialNeeds || $[9] !== minDaysWaiting || $[10] !== preferredName || $[11] !== t || $[12] !== t1 || $[13] !== t3) {
    const t5 = t(`geo:seo.countries.${t3}.name`);
    const t6 = t(`children:child.orphan_${gender as string}_${String(isOrphan)}`);
    const t7 = t(`children:child.specialNeeds_${String(isSpecialNeeds)}`);
    let t8;
    if ($[15] !== country || $[16] !== isInHivAffectedArea) {
      t8 = isInHivAffectedArea && !isHighlyVulnerable(country as string);
      $[15] = country;
      $[16] = isInHivAffectedArea;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    const t9 = t(`children:child.aidsArea_${String(isInHivAffectedArea)}`, {
      aidsOnly: t(`children:child.aidsOnly_${String(t8)}`)
    });
    const t10 = country as string;
    let t11;
    if ($[18] !== t10) {
      t11 = isHighlyVulnerable(t10);
      $[18] = t10;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    let t12;
    if ($[20] !== country || $[21] !== isInHivAffectedArea) {
      t12 = !isInHivAffectedArea && isHighlyVulnerable(country as string);
      $[20] = country;
      $[21] = isInHivAffectedArea;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    t4 = t(t1, {
      country: t5,
      days: minDaysWaiting,
      childName: preferredName,
      koreanName: hangul ? t(`bio:subject_${String(endsWithVowel(hangul.preferred))}`, {
        val: hangul.preferred
      }) : preferredName,
      orphan: t6,
      specialNeeds: t7,
      aidsArea: t9,
      vulnerable: t(`children:child.vulnerable_${String(t11)}`, {
        vulnerableOnly: t(`children:child.vulnerableOnly_${String(t12)}`)
      })
    });
    $[3] = country;
    $[4] = gender;
    $[5] = hangul;
    $[6] = isInHivAffectedArea;
    $[7] = isOrphan;
    $[8] = isSpecialNeeds;
    $[9] = minDaysWaiting;
    $[10] = preferredName;
    $[11] = t;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};